import { API_GET_INFINITY_UPTIME, API_GET_UERS_COST } from "../ApiConstants";
import axios from "../client/rest";

class AvailablityApi {
  static sharedInstance = new AvailablityApi();

  constructor() {
    if (AvailablityApi.sharedInstance !== null) {
      return AvailablityApi.sharedInstance;
    }
  }

  async getInfinityUptime() {
    try {
      const res = await axios.get(API_GET_INFINITY_UPTIME);
      const { data } = res;
      if (res.status === 200) {
        return data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async getUserCost() {
    try {
      const res = await axios.get(API_GET_UERS_COST);
      const { data } = res;
      if (res.status === 200) {
        return data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }
}

export default AvailablityApi.sharedInstance;
